const store = require('../../store/index.js');
const { ExtraConfigKey } = require('@/common/sharedDefinitions/commonPlotDefinitions');

class baseConfCtrller {
    constructor(KeyValue, isExtraConfig = false) {
        this.KeyValue = KeyValue;
        this.OrigKeyValue = KeyValue;
        this.configCategory = '';
        this.isExtraConfig = isExtraConfig;
    }
    setSection(newSection) {
        this.configCategory = newSection;
    }
    formatKeyValue(...argsElems) {
        this.KeyValue = formatString(this.OrigKeyValue, argsElems);
    }
    initializeConfig() {
        if (
            this.configCategory !== '' &&
            !(
                this.configCategory in
                store.default.getters.getCurrentReportViewer.configuration
            )
        ) {
            store.default.getters.getCurrentReportViewer.configuration[
                this.configCategory
            ] = {};
        }
    }
    setConfiguration(configuration_report, key, value) {
        const configuration = this.isExtraConfig
            ? store.default.getters.getCurrentReportViewer[ExtraConfigKey]
            : configuration_report[this.configCategory];
        const splitKey = key.split('.');
        if (splitKey.length === 1) {
            configuration[key] = value;
            return;
        }
        const keyValue = splitKey.pop();
        const objectRef = splitKey.reduce((a, b) => {
            if (typeof a[b] === 'undefined') {
                a[b] = {};
            }
            return a[b];
        }, configuration);
        objectRef[keyValue] = value;
    }
    getOrDefineConfiguration(configuration_report, key, value) {
        const configuration = this.isExtraConfig
            ? store.default.getters.getCurrentReportViewer[ExtraConfigKey]
            : configuration_report[this.configCategory];
        const splitKey = key.split('.');
        if (splitKey.length === 1) {
            if (typeof configuration[key] === 'undefined') {
                configuration[key] = value;
                return undefined;
            }
            return configuration[key];
        }
        const keyValue = splitKey.pop();
        var valueNotDefined = false;
        const objectRef = splitKey.reduce((a, b) => {
            if (typeof a[b] === 'undefined') {
                a[b] = {};
                valueNotDefined = true;
            }
            return a[b];
        }, configuration);
        if (valueNotDefined || typeof objectRef[keyValue] === 'undefined') {
            objectRef[keyValue] = value;
            return undefined;
        }
        return objectRef[keyValue];
    }

    static getConfiguration(configuration, key) {
        const splitKey = key.split('.');
        if (splitKey.length === 1) {
            return configuration[key];
        }
        const keyValue = splitKey.pop();
        const objectRef = splitKey.reduce((a, b) => {
            if (typeof a[b] === 'undefined') {
                a[b] = {};
            }
            return a[b];
        }, configuration);
        return objectRef[keyValue];
    }
}

function formatString(strintToParse, arrElems) {
    return strintToParse.replace(/{(\d+)}/g, function (match, number) {
        return typeof arrElems[number] != 'undefined'
            ? arrElems[number]
            : match;
    });
}

class comboBoxConfCtrller extends baseConfCtrller {
    constructor(
        KeyValue,
        options,
        text = '',
        defaultVal = 0,
        contextHelp = null,
        isExtraConfig = false,
    ) {
        super(KeyValue, isExtraConfig);
        this.options = options;
        this.defaultVal = defaultVal;
        this.text = text;
        this.initializeText();
        this.contextHelp = contextHelp;
    }

    initializeText() {
        if (this.options.length !== 0) {
            this.valueSelection = this.options[this.defaultVal].value;
            this.textSelection = this.options[this.defaultVal].text;
        } else {
            this.valueSelection = '';
            this.textSelection = '';
        }
    }

    changeSelection(newText, newValue) {
        this.valueSelection = newValue;
        this.textSelection = newText;
        super.setConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            newValue,
        );
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        if (this.textSelection === '') {
            this.initializeText();
        }
        if (this.options.length === 0) {
            return;
        }
        const definedValue = super.getOrDefineConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            this.valueSelection,
        );
        if (typeof definedValue !== 'undefined') {
            if (this.options.length === 0) {
                //If there is no options yet defined
                super.setConfiguration(
                    store.default.getters.getCurrentReportViewer.configuration,
                    this.KeyValue,
                    this.valueSelection,
                );

                return;
            }
            let index = this.options.findIndex((x) => x.value === definedValue);
            if (index !== -1) {
                this.valueSelection = this.options[index].value;
                this.textSelection = this.options[index].text;
            }
        }
    }

    isReady() {
        return true;
    }
}

class multiSelComboBoxConfCtrller extends baseConfCtrller {
    constructor(
        KeyValue,
        options,
        text,
        placeholder,
        defaultAllSelected,
        contextHelp = null,
        isExtraConfig = false,
    ) {
        super(KeyValue, isExtraConfig);
        this.options = options;
        this.contextHelp = contextHelp;
        this.value = []
        this.text = text
        this.placeholder = placeholder
        this.defaultAllSelected = defaultAllSelected
    }

    changeSelection(newValue) {
        this.value = newValue;
        super.setConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            newValue,
        );
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        const defaultValue = this.defaultAllSelected ? [...this.options] : []
        const definedValue = super.getOrDefineConfiguration(
            store.default.getters.getCurrentReportViewer.configuration, this.KeyValue, defaultValue);
        this.value = typeof definedValue !== 'undefined' ? definedValue : defaultValue;
        if(!Array.isArray(this.value)){
            this.value = [this.value]
        }
    }

    isReady() {
        return true;
    }
}

class simpleInputTextConfCtrller extends baseConfCtrller {
    constructor(
        KeyValue,
        text,
        defaultValue,
        placeholder = null,
        contextHelp = null,
        isFloat = false,
        isExtraConfig = false,
    ) {
        super(KeyValue, isExtraConfig);
        this.text = text;
        this.defaultValue = defaultValue;
        this.value = '';
        this.setFunction = null; //External function to update. For example Vuex
        this.placeholder = placeholder !== null ? placeholder : text;
        this.contextHelp = contextHelp;
        this.isFloat = isFloat;
    }
    setValue(newValue) {
        if (this.value === newValue) {
            //Avoid call the external functions if not necessary
            return;
        }
        this.value = newValue.toString();
        if (this.isFloat) {
            super.setConfiguration(
                store.default.getters.getCurrentReportViewer.configuration,
                this.KeyValue,
                parseFloat(newValue),
            );
        } else {
            super.setConfiguration(
                store.default.getters.getCurrentReportViewer.configuration,
                this.KeyValue,
                newValue,
            );
        }
        if (this.setFunction !== null) {
            this.setFunction(this.value);
        }
        store.default.commit('SET_ALL_CONFIG_MODIFIED_ReportViewer');
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        const defaultValue = this.isFloat
            ? parseFloat(this.defaultValue.toString())
            : this.defaultValue.toString();
        const definedValue = super.getOrDefineConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            defaultValue,
        );
        this.value =
            typeof definedValue !== 'undefined' ? definedValue : defaultValue;
        if (this.setFunction !== null) {
            this.setFunction(this.value);
        }
    }

    isReady() {
        return true;
    }
}

class inputTextConfCtrller extends simpleInputTextConfCtrller {
    constructor(
        KeyValue,
        text,
        feedback,
        defaultValue,
        condition = () => {
            return true;
        },
        placeholder = null,
        contextHelp = null,
        isFloat = false,
        isExtraConfig = false,
    ) {
        super(KeyValue,text, defaultValue, placeholder, contextHelp, isFloat, isExtraConfig);
        this.feedback = feedback;
        this.condition = condition;
    }

    isReady() {
        //Check if the controller is ready
        return this.condition(this.value);
    }
}

class checkBoxGraphConfCtrller extends baseConfCtrller {
    constructor(
        KeyValue,
        textUser,
        defaultVal = false,
        contextHelp = null,
        isExtraConfig = false,
    ) {
        super(KeyValue, isExtraConfig);
        this.textName = textUser;
        this.value = defaultVal;
        this.defaultValue = defaultVal;
        this.contextHelp = contextHelp;
    }

    setValue(newValue) {
        this.value = newValue;
        super.setConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            newValue,
        );
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        const definedValue = super.getOrDefineConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            this.defaultValue,
        );
        this.value =
            typeof definedValue !== 'undefined'
                ? definedValue
                : this.defaultValue;
    }

    isReady() {
        return true;
    }
}

class genericConfCtrller extends baseConfCtrller {
    constructor(
        KeyValue,
        defaultVal,
        contextHelp = null,
        isExtraConfig = false,
    ) {
        super(KeyValue, isExtraConfig);
        this.value = defaultVal;
        this.defaultValue = defaultVal;
        this.contextHelp = contextHelp;
    }

    setValue(newValue) {
        this.value = newValue;
        super.setConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            newValue,
        );
        store.default.commit('SET_ALL_CONFIG_MODIFIED_ReportViewer');
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        const definedValue = super.getOrDefineConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            this.defaultValue,
        );
        this.value =
            typeof definedValue !== 'undefined'
                ? definedValue
                : this.defaultValue;
    }

    isReady() {
        return true;
    }
}

class fixedConfCtrller extends baseConfCtrller {
    constructor(KeyValue, value) {
        super(KeyValue, false);
        this.value = value;
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        super.setConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            this.value,
        );
    }

    isReady() {
        return true;
    }
}

class hiddenConfCtrller extends baseConfCtrller {
    constructor(KeyValue, value, isExtraConfig = false) {
        super(KeyValue, isExtraConfig);
        this.value = value;
        this.defaultValue = value;
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        const definedValue = super.getOrDefineConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            this.defaultValue,
        );
        this.value =
            typeof definedValue !== 'undefined'
                ? definedValue
                : this.defaultValue;
    }

    setValue(newValue) {
        this.value = newValue;
        super.setConfiguration(
            store.default.getters.getCurrentReportViewer.configuration,
            this.KeyValue,
            newValue,
        );
    }

    isReady() {
        return true;
    }
}

class fakeInputTextConfCtrller extends baseConfCtrller {
    constructor(
        KeyValue,
        text,
        feedback,
        defaultValue,
        condition = () => {
            return true;
        },
        placeholder = null,
        contextHelp = null,
        isFloat = false,
    ) {
        super(KeyValue);
        this.text = text;
        this.feedback = feedback;
        this.condition = condition;
        this.defaultValue = defaultValue;
        this.value = '';
        this.setFunction = null; //External function to update. For example Vuex
        this.placeholder = placeholder !== null ? placeholder : text;
        this.contextHelp = contextHelp;
        this.isFloat = isFloat;
    }

    setValue(newValue) {
        if (this.value === newValue) {
            //Avoid call the external functions if not necessary
            return;
        }
        this.value = newValue.toString();
        if (this.setFunction !== null) {
            this.setFunction(this.value);
        }
        store.default.commit('SET_ALL_CONFIG_MODIFIED_ReportViewer');
    }

    setParent(parent) {
        this.parent = parent;
        this.initializeConfig();
        const defaultValue = this.isFloat
            ? parseFloat(this.defaultValue.toString())
            : this.defaultValue.toString();
        this.value = defaultValue;
        if (this.setFunction !== null) {
            this.setFunction(this.value);
        }
    }
    isReady() {
        //Check if the controller is ready
        return this.condition(this.value);
    }
}

module.exports = {
    comboBoxConfCtrller,
    checkBoxGraphConfCtrller,
    inputTextConfCtrller,
    simpleInputTextConfCtrller,
    genericConfCtrller,
    fixedConfCtrller,
    hiddenConfCtrller,
    fakeInputTextConfCtrller,
    baseConfCtrller,
    multiSelComboBoxConfCtrller,
};
